import { z } from 'zod/v4-mini'

export const availablePageSizes = Object.freeze(
    import.meta.env.VITE_PAGINATION_AVAILABLE_PAGE_SIZES.split(',').map(p =>
        Number.parseInt(p, 10)
    )
)
export const defaultPage = 0
export const defaultPageSize = Number.parseInt(
    import.meta.env.VITE_PAGINATION_DEFAULT_PAGE_SIZE,
    10
)

export const searchParamsPaginationSchema = z.object({
    page: z._default(z.int().check(z.minimum(0)), defaultPage),
    pageSize: z._default(
        z.int().check(
            z.positive(),
            z.refine(ps => ps && availablePageSizes.includes(ps))
        ),
        defaultPageSize
    ),
})

export const searchParamsPaginationDefaultValues: z.infer<
    typeof searchParamsPaginationSchema
> = {
    page: searchParamsPaginationSchema.shape.page.def.defaultValue,
    pageSize: searchParamsPaginationSchema.shape.pageSize.def.defaultValue,
}
